module.exports = __webpack_public_path__ + "static/media/qr-qq.57bd424d.png";